import React from 'react';

export default function PencilIcon() {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 12.67v3.333h3.333l9.832-9.832L9.83 2.838 0 12.669zm15.742-9.077a.885.885 0 0 0 0-1.253L13.662.26a.885.885 0 0 0-1.253 0l-1.627 1.627 3.334 3.333 1.626-1.627z" fill="currentColor" fillRule="evenodd" />
    </svg>
  );
}
